<template>
    <div class="p-3">
        <h3>Daftar Pasien</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Data Pasien" :filter-configs="filterConfigs"
            :table-options="tableOptions" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'tanggal_dari',
                    label: 'Dari',
                    field: 'tanggal_dari',
                    type: 'date',
                    colClass: 'col-sm-3'
                },
                {
                    id: 'tanggal_sampai',
                    label: 'Sampai',
                    field: 'tanggal_sampai',
                    type: 'date',
                    colClass: 'col-sm-3'
                },
                {
                    id: 'search',
                    label: 'No. RM/Nama/NIK/No Kartu BPJS',
                    field: 'search',
                    type: 'text',
                    colClass: 'col-sm-4'
                }
            ],
            tableOptions: {
                baseUrl: '/api/konsul-poli/get-all',
                columns: [
                    { title: 'No. Rekam Medis', field: 'Medrec' },
                    { title: 'Nama Pasien', field: 'Firstname' },
                    { title: 'No. Registrasi', field: 'Regno' },
                    { title: 'Nomor Surat Konsul', field: 'NoSuratKonsul' },
                    { title: 'Poli Asal', field: 'poli_asal' },
                    { title: 'Tanggal Konsul', field: 'tanggal_konsul' },
                    {
                        title: 'Action', formatter: function () {
                            return '<button class="btn btn-sm btn-primary">Detail</button>'
                        }, cellClick: (e, cell) => this.openDetailPage(e, cell)
                    },
                ],
                ajaxResponse: (url, params, response) => response.data_konsul
            }
        }
    },
    methods: {
        openDetailPage(e, cell) {
            const data = cell.getRow().getData()
            const regno = data.Regno

            this.$router.push({
                name: 'konsul_antar_poli_detail',
                params: { Regno: regno }
            })
        },
    }
}
</script>
